export const GET_STOREFRONT_CONFIGURATION = 'GET_STOREFRONT_CONFIGURATION';
export const REDUCE_STOREFRONT_CONFIGURATION = 'REDUCE_STOREFRONT_CONFIGURATION';
export const REDUCE_USER_INTERFACE = 'REDUCE_USER_INTERFACE';
